export default "__VITE_ASSET__CIQxOBMy__"